import OCTRenderQueue from '../../plugins/oct-render-queue'

class OCTParallaxClip {
  constructor (el) {
    if (el.__parallaxClip) return

    this.el = el
    this.$_parallax = this.parallax.bind(this)

    window.addEventListener('scroll', this.$_parallax)
    window.addEventListener('resize', this.$_parallax)

    this.el.__parallaxClip = this
  }

  parallax () {
    let height = window.innerHeight
    let rect = this.el.parentNode.getBoundingClientRect()

    if (rect.bottom <= 0 || rect.top >= height) return

    let per = (height - rect.top)/(height + rect.height)

    let _rect = this.el.getBoundingClientRect()
    let _diff = _rect.height - rect.height
    let d = _diff*per - _diff/2

    let _style = window.getComputedStyle(this.el)
    let matrixScale = +(_style.transform.replace('matrix(', '').split(',')[0])

    OCTRenderQueue.push(() => {
      if (matrixScale)
        this.el.style.transform = 'translateY(' + d + 'px) translateZ(0) scale(' + matrixScale + ')'
      else
        this.el.style.transform = 'translateY(' + d + 'px) translateZ(0)'
    })
  }
}

export default OCTParallaxClip
